module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td id="bill-'+
((__t=( document_type ))==null?'':__t)+
''+
((__t=( number ))==null?'':__t)+
'">\n  <div>\n    <a class="bill-link" href="#bills/'+
((__t=( bill_id ))==null?'':__t)+
'" oncontextmenu="return false">'+
((__t=( document_type ))==null?'':__t)+
' '+
((__t=( number ))==null?'':__t)+
'</a>\n    ';
 if (vetoed === 1) { 
__p+='\n      <i class="fa fa-times red hover not-passed undecorate tipped" title="This bill was vetoed by the Governor"></i>\n    ';
 } else if (bill_passed === 1) { 
__p+='\n      <i class="fa fa-check green hover passed undecorate tipped" title="This bill has been passed by the legislature. If the Governor signs it, or if he does not veto it within 40 days after the end of the session, it becomes law on the bill\'s effective date, commonly July 1."></i>\n    ';
 } else { 
__p+='\n      <i class="fa fa-times red hover not-passed undecorate tipped" title="This bill was not passed by the Georgia General Assembly during the most recent session."></i>\n    ';
 } 
__p+='\n  </div>\n<!--\n     <div class="col-sm-7">\n      ';
 if ( $.isNumeric(predictions) && bill_passed === 0 && passed_over >= 0 ) { 
__p+='\n      <div class="well">\n        ';
 if (caption.match(/(General|Supplemental) appropriations.*201(5|4)/)) { 
__p+='\n          <p>This is a budget bill and must pass for state government to continue operating. We do not assign a probability to budget bills.<p>\n        ';
 } else if (passed_over >= 0 ) { 
__p+='\n          <p>Chance of passing \n          <svg class="tipped info-tip" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><title>Forecasts of each bill’s chance of passage this year are generated from a statistical model developed by the AJC based on the success or failure of bills from legislative sessions from 2005 to 2014. The model accounts for a variety of factors, including sponsorship, the number of days remaining in the session and the current progress each bill has made so far. The technique used by the AJC was tested on previous legislative sessions.</title><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>: <span class="big"><nobr>'+
((__t=( predictions < .01 ? '< 1' : (predictions * 100).toFixed() ))==null?'':_.escape(__t))+
'%</nobr></span></p>\n        ';
 } 
__p+='\n      </div>\n      ';
 } 
__p+='\n    </div>\n -->\n</td>\n<td class="bill-description">'+
((__t=( caption ))==null?'':__t)+
'</td>\n<td>'+
((__t=( status_description ))==null?'':__t)+
'</td>\n';
}
return __p;
};
